import WidgetModule from "@eisinc/Overrides/Widgets/SignIn/SignInCreateNewAccount";

export * from "@eisinc/Overrides/Widgets/SignIn/SignInCreateNewAccount";

export default WidgetModule;
